module.exports = {"513432100":"光明镇","513432101":"冕山镇","513432102":"红莫镇","513432103":"两河口镇","513432104":"米市镇","513432105":"洛哈镇","513432106":"尼波镇","513432202":"贺波洛乡","513432203":"鲁基乡","513432204":"李子乡","513432205":"北山乡","513432208":"且拖乡","513432210":"沙马拉达乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513432.json
// module id = 2573
// module chunks = 0